import {httpAuth} from './config';

export default {
    update:(userCompany) => {
        return httpAuth.put('v1/usuariosCompanhiasGrupos/' + userCompany.id, userCompany);
    }, 
    list: () => {
        return httpAuth.get('v1/usuariosCompanhiasGrupos/listarCompanhias/admin');
    },
    onOff:(id) => {
        return httpAuth.patch(`api/external/user-company/onOff/${id}`);
    },
    updateGlobalGroup:(id, groups) => httpAuth.put(`api/external/user-company/${id}/groupGlobal`,groups),
    setCusomGroup:(data) => httpAuth.post(`api/external/user-company/groupsCustom`,data),
    getScopeGlobalByUserCompanyId:(id) => httpAuth.get(`api/external/user-company/${id}/global-scope`),
    chanceCustomScope:($allotmentId) => httpAuth.get(`api/external/auth/change-scope/${$allotmentId}`)
}
